import Loader from './Loader';
import './Loader.scss';

export default Loader;
